import styled from "styled-components";
import { breakpoints } from "theme/themes";

const StyledMenu = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundLight};
  min-height: 100vh;
  height: fit-content;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;
  width: 100%;
  padding: 24px 16px;
  transition: 300ms;
  overflow-y: scroll;
  height: 100vh;

  transform: ${(props) => (props.isMenuOpen ? "translateX(0)" : "translateX(110%)")};

  @media ${breakpoints.medium} {
    padding: 24px 48px;
  }

  @media ${breakpoints.larger} {
    width: 680px;
  }

  .button-back-to-start {
    margin-top: 2rem;
    button {
      cursor: pointer;
      display: flex;
      align-items: center;

      .label {
        margin-left: 8px;
        display: inline-block;
        font-family: ${({ theme }) => theme.fonts.fontMedium};
        color: #595959;

        @media ${breakpoints.medium} {
          font-size: 20px;
        }

      }
    }
  }

  .menu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .menu__logos {
    margin-right: 1rem;

    .body-talk-logo {
      margin-right: 1.5rem;

      img {
        width: 64px;

        @media ${breakpoints.medium} {
          width: 100px;
        }
      }
    }

    .family-planning-logo {
      position: relative;
      z-index: 1;
      img {
        width: 78px;

        @media ${breakpoints.medium} {
          width: 120px;
        }
      }
    }
  }

  .menu__items-listing {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 4rem;

    .scenario-item {
      margin-bottom: 3.5rem;

      @media ${breakpoints.larger} {
        margin-bottom: 2.5rem;
        align-self: flex-end;

        &:nth-of-type(2n + 2) {
          align-self: flex-start;
        }
      }

      @media (max-width: 960px) {
        &:nth-of-type(2n + 2) {
          .bubble-talk::after {
            border-left: none;
            border-right: 40px solid #00a89d;
            right: 0;
            left: unset;
          }
        }
      }
    }

    .bubble-talk {
      max-width: 400px;
    }
  }
`;

export default StyledMenu;
